import { render, staticRenderFns } from "./OnboardingIndex.vue?vue&type=template&id=407d4dc7&"
import script from "./OnboardingIndex.vue?vue&type=script&lang=js&"
export * from "./OnboardingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports